import React from "react";

import { Select, Spin } from "antd";
import { Dayjs } from "dayjs";
import i18next from "i18next";
import styled from "styled-components";

import { useGetMpDistributors } from "api/reactQuery/queryComponents";
import {
  BSCoreWebRequestsResponsesDistributorsDistributorDepotResponse,
  BSCoreWebRequestsResponsesDistributorsDistributorResponse,
} from "api/reactQuery/querySchemas";

const OrderInfoLabel = styled.p`
  color: #6d6d6d;
  font-size: 12px;
  line-height: 20px;
`;

type Props = {
  resetCalculatedData: () => void;
  setSelectedDistributor: React.Dispatch<
    React.SetStateAction<BSCoreWebRequestsResponsesDistributorsDistributorResponse>
  >;
  setSelectedDepots: React.Dispatch<
    React.SetStateAction<
      BSCoreWebRequestsResponsesDistributorsDistributorDepotResponse[]
    >
  >;
  setDeliveryDate: React.Dispatch<React.SetStateAction<Dayjs>>;
  selectedDistributor: BSCoreWebRequestsResponsesDistributorsDistributorResponse;
};

const SelectDistributorStep: React.FC<Props> = ({
  resetCalculatedData,
  setSelectedDistributor,
  setSelectedDepots,
  setDeliveryDate,
  selectedDistributor,
}) => {
  const { data: distributors, isLoading: distributorsLoading } =
    useGetMpDistributors({});

  return (
    <Wrapper>
      <h1 style={{ fontSize: 30, marginBottom: 20, marginTop: 20 }}>
        {i18next.t("select_distributor")}
      </h1>
      <div>
        <OrderInfoLabel>{i18next.t("distributor_name")}</OrderInfoLabel>
        {distributorsLoading ? (
          <Spin />
        ) : (
          <Select
            style={{ minWidth: 250 }}
            placeholder={i18next.t("select_distributor")}
            loading={distributorsLoading}
            defaultValue={selectedDistributor ? selectedDistributor?.id : null}
            showSearch
            filterOption={(input, option) => {
              return (
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
            onChange={(value) => {
              resetCalculatedData();
              setSelectedDepots([]);
              setDeliveryDate(undefined);
              setSelectedDistributor({
                id: value,
                officialDistributorName:
                  distributors?.find((distributor) => distributor.id === value)
                    .officialDistributorName || i18next.t("no_name"),
              });
            }}
            options={distributors?.map((distributor) => ({
              label:
                distributor.officialDistributorName || i18next.t("no_name"),
              value: distributor.id,
            }))}
          />
        )}
      </div>
    </Wrapper>
  );
};

export default SelectDistributorStep;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
